/* import __COLOCATED_TEMPLATE__ from './code.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { setInputEnterKeyHint, updateError } from '@square/ember-multipass-components/utils/ember-multipass-input-util';
let SecureContactModalEnrollCodeComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class SecureContactModalEnrollCodeComponent extends Component {
  get verificationCodeLengthErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.verification_code_length';
  }
  get invalidAliasErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.invalid_alias';
  }
  get invalidVerificationCodeErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.invalid_verification_code';
  }
  get secureContactAliasConflictErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.secure_contact_alias_conflict';
  }
  get secureContactConflictErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.secure_contact_conflict';
  }
  get secureContactVerificationRequiredErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.pre_verification_required';
  }
  get temporaryLockoutErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.temporary_lockout';
  }
  get unknownErrorTLabel() {
    return 'secure_contact_modals.enroll.generic.errors.unknown';
  }
  get toastEmailAddedTLabel() {
    return 'secure_contact_modals.toasts.email_added';
  }
  get toastPhoneAddedTLabel() {
    return 'secure_contact_modals.toasts.phone_added';
  }
  get isPhoneMethod() {
    return this.args.method === this.args.methods.PHONE;
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor4, this);
    _initializerDefineProperty(this, "codeError", _descriptor5, this);
    _initializerDefineProperty(this, "loading", _descriptor6, this);
    _initializerDefineProperty(this, "validating", _descriptor7, this);
    _defineProperty(this, "code", '');
    _defineProperty(this, "codeInput", void 0);
    _defineProperty(this, "handleCodeInputDidInsert", element => {
      this.codeInput = element;
    });
  }
  updateCodeError(err) {
    if (err) {
      this.codeError = err;
      updateError(this.codeInput, 'code-error');
    } else if (this.code.length < 6) {
      this.codeError = this.intl.t(this.args.tPrefix + this.verificationCodeLengthErrorTLabel);
      updateError(this.codeInput, 'code-error');
    } else {
      this.codeError = undefined;
      updateError(this.codeInput);
    }
  }
  checkEnterPressed(event) {
    if (event.key === 'Enter') {
      this.submitDebounced();
    }
  }
  updateCode(event) {
    const currentInput = document.querySelector('.verification-code-input').shadowRoot.activeElement;
    if (!currentInput.hasAttribute('enterKeyHint')) {
      setInputEnterKeyHint(currentInput, 'go');
    }
    this.code = event.detail.code;
    if (this.validating) {
      this.updateCodeError();
    }
  }
  submitDebounced() {
    debounce(this, this.submit, 500, true);
  }
  async submit() {
    this.validating = true;
    this.updateCodeError();
    if (this.codeError || this.loading) {
      return;
    }
    try {
      this.loading = true;
      const data = {
        verification_code: this.code
      };
      if (this.isPhoneMethod) {
        data.secure_contact_details = {
          phone: this.args.phoneNumber
        };
      } else {
        data.secure_contact_details = {
          email: this.args.email
        };
      }
      if (this.args.detailToBeUpdated) {
        data.old_secure_contact_details = this.args.detailToBeUpdated;
        await this.multipassfeClient.updateSecureContact(data);
      } else {
        await this.multipassfeClient.enrollSecureContact(data);
      }
      this.handleToast();
      this.args.next();
    } catch (e) {
      switch (e.message) {
        case 'INVALID_ALIAS':
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.invalidAliasErrorTLabel));
          break;
        case 'INVALID_CREDENTIALS':
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.invalidVerificationCodeErrorTLabel));
          break;
        case 'SECURE_CONTACT_ALIAS_CONFLICT':
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.secureContactAliasConflictErrorTLabel));
          break;
        case 'SECURE_CONTACT_CONFLICT':
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.secureContactConflictErrorTLabel));
          break;
        case 'SECURE_CONTACT_VERIFICATION_REQUIRED':
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.secureContactVerificationRequiredErrorTLabel));
          break;
        case 'TEMPORARY_LOCKOUT':
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.temporaryLockoutErrorTLabel));
          break;
        default:
          this.logger.sentryError(e);
          this.updateCodeError(this.intl.t(this.args.tPrefix + this.unknownErrorTLabel));
      }
    } finally {
      this.loading = false;
    }
  }
  handleToast() {
    if (this.isPhoneMethod) {
      this.marketToasts.success(this.args.phoneNumberDisplay + ' ' + this.intl.t(this.args.tPrefix + this.toastPhoneAddedTLabel));
    } else {
      this.marketToasts.success(this.args.email + ' ' + this.intl.t(this.args.tPrefix + this.toastEmailAddedTLabel));
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "codeError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "validating", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "checkEnterPressed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "checkEnterPressed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _class);
export { SecureContactModalEnrollCodeComponent as default };